import React from "react";
import { DISCLAIMER } from "../api";
import { Info } from "@phosphor-icons/react";

export default function Disclaimer({ className = "" }) {
  return (
    <div
      data-testid="virtual-currency-disclaimer"
      className={`flex items-start gap-2 rounded-sm border border-ff-brass/30 bg-ff-bg2/60 px-4 py-3 text-xs text-ff-muted ${className}`}
    >
      <Info size={16} weight="duotone" className="mt-0.5 shrink-0 text-ff-brass" />
      <span>{DISCLAIMER}</span>
    </div>
  );
}
